/**
 * Client mirror of cloudflare-oauth-worker/src/lib/virginiaTribute.js — keep in sync.
 */

export const VIRGINIA_STATE_ID = '51';
export const WEST_VIRGINIA_STATE_ID = '54';

/** Virginia and West Virginia share one memorial switch. */
export function isVirginiaTributeState(stateId) {
  return stateId === VIRGINIA_STATE_ID || stateId === WEST_VIRGINIA_STATE_ID;
}

export const VIRGINIA_TRIBUTE_FAMILY_EMAILS = [
	'jimcombs1617@gmail.com',
	'clarecombs3165@gmail.com',
	'edmundcombs@gmail.com',
	'joseph.e.combs@gmail.com',
];

const FAMILY_EMAILS = new Set(VIRGINIA_TRIBUTE_FAMILY_EMAILS.map((e) => e.toLowerCase()));

export function normalizeEmail(email) {
  return (email || '').trim().toLowerCase();
}

export function isVirginiaTributeFamily(userOrEmail) {
  const email = typeof userOrEmail === 'string' ? userOrEmail : userOrEmail?.email;
  return FAMILY_EMAILS.has(normalizeEmail(email));
}

export function isVirginiaTributeActive(user) {
  if (!isVirginiaTributeFamily(user)) return false;
  return user?.showVirginiaTribute !== false;
}

/**
 * Sidebar Virginia button — face centered in frame (map uses separate SVG anchor).
 */
export const VIRGINIA_TRIBUTE_PHOTO_POSITION = '50% 65%';

/** SVG pattern image placement inside Virginia path (objectBoundingBox). */
export const VIRGINIA_TRIBUTE_PATTERN_IMAGE = {
  x: 0.16,
  y: 0.13,
  width: 1.0,
  height: 1.0,
};

/**
 * Sidebar West Virginia button. The crop is square and the button is a short strip,
 * so this position keeps her smile in the visible band.
 */
export const WEST_VIRGINIA_TRIBUTE_PHOTO_POSITION = '50% 58%';

/**
 * SVG pattern image placement inside the West Virginia path (objectBoundingBox).
 * The state bounding box is nearly square, and the sunset portrait is square, so a
 * full-bleed image puts her face in the main body and sky in the northern panhandle.
 */
export const WEST_VIRGINIA_TRIBUTE_PATTERN_IMAGE = {
  x: 0,
  y: 0,
  width: 1,
  height: 1,
};

export function virginiaTributePatternId(tier, playMode, stateId = VIRGINIA_STATE_ID) {
  const prefix =
    stateId === WEST_VIRGINIA_STATE_ID ? 'platechase-wv-tribute' : 'platechase-va-tribute';
  if (tier === 'current_month') {
    return playMode === 'monthly' ? `${prefix}-orange` : `${prefix}-green`;
  }
  if (tier === 'window_only') return `${prefix}-orange`;
  return `${prefix}-gray`;
}

export function virginiaTributeToggleOverlay(tier, playMode) {
  if (tier === 'current_month') {
    return playMode === 'monthly' ? 'rgba(255, 87, 34, 0.48)' : 'rgba(46, 125, 50, 0.52)';
  }
  if (tier === 'window_only') return 'rgba(255, 87, 34, 0.48)';
  return 'rgba(236, 239, 241, 0.58)';
}
